import { IPortfolioMainEntity } from "@domains/features/Quotes/MutualFundsQuotes/entities/iPortfolioHoldingAssetentity";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { chartColors } from "./PortfolioConstant";

interface IChartData {
  chartData: IPortfolioMainEntity;
  limitItems?: boolean;
}
interface IPieChartData {
  name: string;
  y: number;
}
// const cData={"List": [{"name": "Equity", "perc_hold": "90.6400"},{"name": "Reverse Repo", "perc_hold": "4.2900"},{"name": "Net CA & Others", "perc_hold": "5.0700"}]};
const GetData = (chartData: IPortfolioMainEntity) => {
  const data: Array<IPieChartData> = [];
  chartData?.List?.map((asset, idx) => {
    data.push({ name: asset.name, y: Number(asset.perc_hold) });
  });
  return data;
};
const PortfolioPieChart: React.FC<IChartData> = React.memo(
  ({ chartData, limitItems }) => {
    let items = chartData.List;

    let totalPercentage: number = 0;
    for (const item of items) {
      totalPercentage += Number(item.perc_hold);
    }
    if (limitItems && limitItems === true) {
      items = items.slice(0, 2);
    }
    totalPercentage = Number(totalPercentage.toFixed()); // keep 0 decimals in center
    const donutchartOptions: any = {
      colors: chartColors.slice(0, chartData?.List?.length),
      chart: {
        type: "pie",
        alignTicks: false,
        spacingTop: 0,
        spacingLeft: 0,
        spacingRight: 0,
        spacingBottom: 0,
        height: 230,
      },
      title: {
        text: "",
      },
      tooltip: {
        valueSuffix: "%",
      },
      plotOptions: {
        pie: {
          allowPointSelect: false,
          //cursor: "pointer",
          dataLabels: {
            enabled: false,
            format: "{point.name}: {y} %",
          },
          showInLegend: false,
        },
      },
      series: [
        {
          name: "Percentage",
          colorByPoint: true,
          innerSize: "50%",
          data: GetData(chartData),
        },
      ],
    };
    return (
      <>
        <Row className="assetallocation-section aligncenteritem  posrel mx-0">
          <Col lg={11} className="posrel">
            <div className="posrel">
              <HighchartsReact
                highcharts={Highcharts}
                options={donutchartOptions}
              />
            </div>
            <span className="percentage-value-section RobotoM_16_500 txt_blackOne1">
              {totalPercentage}%
            </span>
          </Col>
        </Row>
        <div className="assetallocation-section padding-class-asset posrel mx-0">
          <div className="mgt-15">
            {items.map((asset, idx) => {
              if (idx < 6)
                return (
                  <div className="grid-1 align-items-center pb-10">
                    <div className="table-layout-content-grid-2">
                      <span className="DMSansMedium_16_500 txt_secondary-gray table-layout-content-grid ">
                        <div
                          className="lenged-Circle me-2 mt-1"
                          style={{ backgroundColor: chartColors[idx] }}
                        ></div>
                        <div className="text-left assetname  text-wrap">
                          {asset.name}
                        </div>
                      </span>
                      <span className="RobotoM_16_500 txt_blackOne1 perc-hold-content text-right text-nowrap">
                        {" "}
                        {asset.perc_hold + "%"}
                      </span>
                    </div>
                  </div>
                );
            })}
          </div>
        </div>
      </>
    );
  },
);

export default PortfolioPieChart;
